import { useEffect, useRef } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

/**
 * Toda navegacao PARA FRENTE comeca no topo. Sem isto, abrir um detalhe a partir do meio
 * de uma lista longa cai na mesma altura de rolagem da tela anterior, e o aluno acha que
 * a pagina nao carregou.
 *
 * MENOS a navegacao POP — o botao voltar do navegador (R2 do spec r3/10, "voltar preserva
 * a posicao na lista"). O navegador ja restaura sozinho a altura de uma entrada de
 * historico; este efeito rodava tambem nela e jogava tudo para o topo, desfazendo a
 * restauracao nativa. Quem clica em "ver histórico" no meio da tabela de temas e volta
 * precisa reencontrar a linha de onde saiu.
 *
 * `useNavigationType` e o unico jeito de distinguir os dois: `pathname` e igual nos dois
 * casos, e `Link state` / `history.state` nao ajudam, porque o botao voltar do navegador
 * nao passa por codigo nenhum da aplicacao.
 *
 * A restauracao so acontece de verdade porque a tela repinta do cache do React Query
 * (`useProgressAnalysis` tem `placeholderData`): sem conteudo o navegador nao teria altura
 * para onde rolar.
 *
 * SO A TROCA DE ROTA ROLA A PAGINA — e a parte que e facil errar, porque `navigationType`
 * precisa estar nas dependencias (o efeito o le) mas NAO pode ser gatilho.
 * `useNavigationType` devolve 'PUSH' | 'REPLACE' | 'POP' e muda a CADA navegacao, inclusive
 * nas de mesma rota: todo `setSearchParams(..., { replace: true })` a leva para 'REPLACE'.
 * Sem a guarda de `pathname` anterior, o efeito reexecutaria a cada escrita de query string
 * e a pagina saltaria para o topo a cada filtro digitado, cada trilha expandida e cada
 * troca de periodo — em toda a area /app, nao so nestas telas.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()
  const navigationType = useNavigationType()
  const previousPathname = useRef<string | null>(null)

  useEffect(() => {
    // Mesma rota, so a query string mudou: nada a fazer. A rolagem pertence a navegacao
    // entre telas, e nao a filtro nem a acordeao.
    if (previousPathname.current === pathname) return

    previousPathname.current = pathname

    if (navigationType === 'POP') return

    window.scrollTo(0, 0)
  }, [pathname, navigationType])

  return null
}
